import { CustomTableComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsFullWidthContentLayout } from 'modules/settings/components';
import { ActiveDirectoryListItem } from './active-directory-list-item.vm';
import { ActiveDirectoryTooltipedAddButtonComponent } from './components';
import { useActiveDirectoryList, useDefaultConfigActiveDirectoryList } from './hooks';

interface SettingsIntegrationsActiveDirectoryListComponentProps {
    directories: ActiveDirectoryListItem[];
    loading: boolean;
    isAddDisabled: boolean;
    isLimitReached: boolean;
    onClickRow: (id: string) => void;
    onAddDirectory: () => void;
}

export const SettingsIntegrationsActiveDirectoryListComponent: React.FC<
    SettingsIntegrationsActiveDirectoryListComponentProps
> = ({ directories, loading, isAddDisabled, isLimitReached, onClickRow, onAddDirectory }) => {
    const { t } = useTranslation();
    const { defaultConfig } = useDefaultConfigActiveDirectoryList();

    const { selectedRows, scrollContainerRef, setSelectedRows, handleOnSelectRows } = useActiveDirectoryList({
        activeDirectories: directories,
    });

    return (
        <SettingsFullWidthContentLayout
            title={t('settings.integrations.active-directory.list.title')}
            description={t('settings.integrations.active-directory.list.description')}
            scrollContainerRef={scrollContainerRef}
            actionsContent={
                <ActiveDirectoryTooltipedAddButtonComponent
                    disabled={isAddDisabled}
                    isLimitReached={isLimitReached}
                    onClick={onAddDirectory}
                />
            }
        >
            <CustomTableComponent<ActiveDirectoryListItem>
                headerTitle={t('settings.integrations.active-directory.list.title')}
                loading={loading}
                totalElements={directories.length}
                tableData={directories}
                onClickRow={onClickRow}
                config={defaultConfig}
                emptyMessage={t('settings.integrations.active-directory.list.empty')}
                horizontalScroll
                scrollContainerRef={scrollContainerRef}
                showSelectionColumn={false}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                onSelectRow={handleOnSelectRows}
            />
        </SettingsFullWidthContentLayout>
    );
};
